<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Manage Zones | Urban Load Balance</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add Zone | ULB</b-button>
					<b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(areacode)="row">
										<b-link :href="'/devices/'+row.value">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
										<b-button pill variant="success" class="mr-1" v-if="$root.chkperm('page_ulbs','schedule')" @click="showScheduleModal(row.item)" size="sm">SCHEDULE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Zone | ULB':'Add Zone | ULB'" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="State" label-for="fp-input" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.state" :options="$root.state_options" required></b-form-select>
					</b-form-group>
					<b-form-group label="City" label-for="fp-input" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.city">
							<b-form-select-option value="0">--- Select City ---</b-form-select-option>
							<b-form-select-option v-for="item in filterCities(cities)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Title" label-for="title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Title is required">
						<b-form-input v-model="selectedItem.title" required></b-form-input>
					</b-form-group>
					<b-form-group label="Area Code" label-for="areacode" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.areacode" required></b-form-input>
					</b-form-group>
					<b-form-group label="Location" label-for="ulb" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.location" required></b-form-input>
					</b-form-group>
					<b-form-group label="Previous Load (KW)" label-for="prevload" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.previous_load" required></b-form-input>
					</b-form-group>
					<b-form-group label="Tariff Rate" label-for="tariffrate" label-cols="3" label-size="sm" label-align-sm="right" v-if="$root.chkperm('tariff_rate','edit') || selectedItem.id==0">
						<b-form-input v-model="selectedItem.tariff_rate" required></b-form-input>
					</b-form-group>
					<b-form-group label="Zoom Level" label-for="ulb" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.zoom">
							<b-form-select-option value="9">9</b-form-select-option>
							<b-form-select-option value="10">10</b-form-select-option>
							<b-form-select-option value="11">11</b-form-select-option>
							<b-form-select-option value="12">12</b-form-select-option>
							<b-form-select-option value="13">13</b-form-select-option>
							<b-form-select-option value="14">14</b-form-select-option>
							<b-form-select-option value="14">15</b-form-select-option>
							<b-form-select-option value="14">16</b-form-select-option>
							<b-form-select-option value="14">17</b-form-select-option>
							<b-form-select-option value="14">18</b-form-select-option>
							<b-form-select-option value="14">19</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="On Time" label-for="ulb" label-cols="3" label-size="sm" label-align-sm="right" v-if="$root.chkperm('schedule','edit') || selectedItem.id==0">
						<b-form-input v-model="selectedItem.on_time" required placeholder="HH:MM"></b-form-input>
					</b-form-group>
					<b-form-group label="Off Time" label-for="ulb" label-cols="3" label-size="sm" label-align-sm="right" v-if="$root.chkperm('schedule','edit') || selectedItem.id==0">
						<b-form-input v-model="selectedItem.off_time" required placeholder="HH:MM"></b-form-input>
					</b-form-group>
					<b-form-group label="Fixed Load" label-for="fixedload" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.fixed_load" required placeholder="0"></b-form-input>
					</b-form-group>
					<b-form-group label="Fixed LED" label-for="fixedled" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.fixed_led" required placeholder="0"></b-form-input>
					</b-form-group>
					<b-form-group label="SMS Mobile" label-for="ulb" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input type="number" v-model="selectedItem.sms_mobile" required></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-for="status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="statusOptions" required></b-form-select>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
		this.loadCities();
	},
	sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
        },
		commtoser_res(data){
			alert(data);
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		}
    },
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
			citiesUrl: self.$session.get('apiurl')+'api/city-record',
			recordUrl: self.$session.get('apiurl')+'api/zone-record',
			insertUrl: self.$session.get('apiurl')+'api/zone-insert',
			updateUrl: self.$session.get('apiurl')+'api/zone-update',
			deleteUrl: self.$session.get('apiurl')+'api/zone-delete',
			records: [],
			cities: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			zoneOptions: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'state', label: 'State', sortable: true, sortDirection: 'desc', 
					formatter: (value, key, item) => {
						var state = '';
						self.$root.state_options.forEach(obj => {
							if(obj.value === item.state){
								state = obj.text;
								return state;
							}
						});
						return state;
					},
				},
				{ key: 'title', label: 'Zone'},
				{ key: 'ulb', label: 'Urban Load Balance (ULB)' },
				{ key: 'areacode', label: 'Area Code', },
				{ key: 'location', label: 'Location' },
				{ key: 'previous_load', label: 'Prev. Load' },
				{ key: 'tariff_rate', label: 'Tariff Rate' },
				{ key: 'schedule', label: 'Schedule' ,
					formatter: (value, key, item) => {
						if(item.on_time != ""){
							return item.on_time+' - '+item.off_time;
						}
						return '-n/a-';
					},
				},
				{ key: 'sms_mobile', label: 'SMS' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				parent: 1,
			},
			emptyItem: {
				id: 0,
				state: '',
				city: 0,
				title: '',
				parent: 1,
				location: '',
				zoom: 11,
				status: 0
			}
		};
	},
	methods: {
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				console.log(self.selectedItem.id+" "+item.value+" "+item.parent);
				return item.state  == self.selectedItem.state && item.value != self.selectedItem.id;
			})
		},
		filterCities: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state_id == self.selectedItem.state;
			})
		},
		showScheduleModal(item){
			//var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to instant apply Schedule?', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					if(this.$socket.connected){
						console.log("SOCKET CONENCTED AND SENDING COMMAND");
						
						this.$socket.emit('applyschedule', item.id);
					}
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.parent > 0){
				this.selectedItem.title = item.ulb;
			}
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Zone or ULB.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		loadCities(){
			var self = this;
			self.axios.post(self.citiesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.cities = response.data.result;
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;

					/*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
					self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
					});
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>